

/**
 * AuthSocialForm
 * - Toggle between Login and Registration views
 * - Social-only auth: Google, Facebook, Instagram
 * - Brand-compliant buttons (colors, logos, accessible labels)
 *
 * Wire up these handlers to your real OAuth flows:
 *   - handleGoogleAuth()
 *   - handleFacebookAuth()
 *   - handleInstagramAuth()
 */

import { useLanguage } from '../i18n/LanguageContext';

export default function AuthSocialForm({error}) {

  const { strings } = useLanguage();


  const handleGoogleAuth = () => {
   window.open(process.env.REACT_APP_GOOGLEAUTH_URL, 'googleLogin', 'width=600,height=700'); 
  };
   const handleLinkedInAuth = () => {

    alert("This feature is not available yet. Coming soon");
    console.log("Linkedin auth clicked");
  };
  const handleFacebookAuth = () => {

    alert("This feature is not available yet. Coming soon");
    console.log("Facebook auth clicked");
  };
  const handleInstagramAuth = () => {

    alert("This feature is not available yet. Coming soon");
    console.log("Instagram auth clicked");
  };

  return (
    <div style={styles.container} aria-labelledby="auth-title">
    <script src="https://accounts.google.com/gsi/client" async defer></script>
       <p style={{ fontWeight: 'bold', color: 'red' }}>
        {error}
      </p>
      <h2 id="auth-title" style={styles.title}>
        {strings.auth.auth_title}
      </h2>

      

      {/* ---- Form Header / Helper Text ---- */}
      <p style={styles.helper}>
        {strings.auth.auth_signin_message}
      </p>

    
    
      <div style={styles.buttonGroup} role="group" aria-label="Authentication options">
        <BrandButton
          brand="google"
          label={strings.auth.auth_signin_google}
          onClick={handleGoogleAuth}
        />
        <BrandButton
          brand="linkedin"
          label={strings.auth.auth_signin_linkedin}
          onClick={handleLinkedInAuth}
        />
        <BrandButton
          brand="facebook"
          label={strings.auth.auth_signin_facebook}
          onClick={handleFacebookAuth}
        />
        <BrandButton
          brand="instagram"
          label={strings.auth.auth_signin_instagram}
          onClick={handleInstagramAuth}
        />
      </div>

 
      <Divider text="or" />

      <div style={styles.infoPanel} aria-live="polite">
          <ul style={styles.infoList}>
            <li>{strings.auth.auth_info_message1}</li>
          </ul>
      </div>
    </div>

  );
}

/* ---------- Brand Button Component ---------- */
function BrandButton({ brand, label, onClick }) {
  const palette = {
    google: { bg: "#FFFFFF", fg: "#3C4043", border: "#DADCE0" },
    facebook: { bg: "#1877F2", fg: "#FFFFFF", border: "transparent" },
    instagram: { bg: "#E1306C", fg: "#FFFFFF", border: "transparent" },
    linkedin: {backgroundColor: "#0A66C2",color: "#FFFFFF", borderColor: "transparent"}
  }[brand];

  const icon = {
    google: GoogleLogo,
    facebook: FacebookLogo,
    instagram: InstagramLogo,
    linkedin: LinkedInLogo,
  }[brand];

  const Icon = icon;

  // Accessible button with brand styles
  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={label}
      style={{
        ...styles.brandButton,
        backgroundColor: palette.bg,
        color: palette.fg,
        borderColor: palette.border,
      }}
    >
      <span style={styles.iconWrap} aria-hidden="true">
        <Icon />
      </span>
      <span style={styles.btnText}>{label}</span>
    </button>
  );
}

/* ---------- Inline SVG Logos (brand-compliant) ---------- */

// Google "G" logo (multi-color)
function GoogleLogo() {
  return (
    <svg width="18" height="18" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg" role="img">
      <path fill="#FFC107" d="M43.6 20.5H42V20H24v8h11.3c-1.6 4.6-6 8-11.3 8-6.9 0-12.5-5.6-12.5-12.5S17.1 11 24 11c3.2 0 6.1 1.2 8.3 3.2l5.7-5.7C34.3 5.3 29.4 3 24 3 12.3 3 3 12.3 3 24s9.3 21 21 21c10.4 0 19.1-7.4 20.6-17.1.1-.7.1-1.4.1-2.1 0-1.6-.1-3.2-.1-3.3z"/>
      <path fill="#FF3D00" d="M6.3 14.7l6.6 4.8C14.5 16 19 13 24 13c3.2 0 6.1 1.2 8.3 3.2l5.7-5.7C34.3 5.3 29.4 3 24 3 16 3 8.9 7.3 6.3 14.7z"/>
      <path fill="#4CAF50" d="M24 45c5.4 0 10.3-2 14-5.2l-6.6-5.4C29.1 35.8 26.7 36 24 36c-5.3 0-9.8-3.4-11.4-8.1l-6.6 5.1C8.8 39.8 15.8 45 24 45z"/>
      <path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3c-1.5 4.3-5.4 7.5-10.1 8.7l6.6 5.4C36.7 39.9 42 33.9 43.6 24c.1-.7.1-1.4.1-2.1 0-1.6-.1-3.2-.1-3.3z"/>
    </svg>
  );
}

// Facebook "f" logo (solid)
function FacebookLogo() {
  return (
    <svg width="18" height="18" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" role="img">
      <path
        d="M19 6h3V0h-3c-4.4 0-8 3.6-8 8v4H6v6h5v14h6V18h5l1-6h-6V8c0-1.1.9-2 2-2z"
        fill="#FFFFFF"
      />
    </svg>
  );
}

// Instagram glyph (solid)
function InstagramLogo() {
  return (
    <svg width="18" height="18" viewBox="0 0 448 512" xmlns="http://www.w3.org/2000/svg" role="img">
      <path
        fill="#FFFFFF"
        d="M224 202.7c-31.4 0-56.9 25.5-56.9 56.9s25.5 56.9 56.9 56.9 56.9-25.5 56.9-56.9-25.5-56.9-56.9-56.9zm124.6-41.1c0 14.1-11.4 25.5-25.5 25.5s-25.5-11.4-25.5-25.5 11.4-25.5 25.5-25.5 25.5 11.4 25.5 25.5zM224 80c60.8 0 68.1.2 92.1 1.3 23.6 1 36.4 4.9 44.9 8.1 10.9 4.2 18.7 9.3 26.9 17.5 8.2 8.2 13.3 16 17.5 26.9 3.2 8.5 7.1 21.3 8.1 44.9 1.1 23.9 1.3 31.3 1.3 92.1s-.2 68.1-1.3 92.1c-1 23.6-4.9 36.4-8.1 44.9-4.2 10.9-9.3 18.7-17.5 26.9-8.2 8.2-16 13.3-26.9 17.5-8.5 3.2-21.3 7.1-44.9 8.1-23.9 1.1-31.3 1.3-92.1 1.3s-68.1-.2-92.1-1.3c-23.6-1-36.4-4.9-44.9-8.1-10.9-4.2-18.7-9.3-26.9-17.5-8.2-8.2-13.3-16-17.5-26.9-3.2-8.5-7.1-21.3-8.1-44.9C80.2 292.1 80 284.7 80 224s.2-68.1 1.3-92.1c1-23.6 4.9-36.4 8.1-44.9 4.2-10.9 9.3-18.7 17.5-26.9 8.2-8.2 16-13.3 26.9-17.5 8.5-3.2 21.3-7.1 44.9-8.1C155.9 80.2 163.3 80 224 80m0-32C163 48 155.1 48.2 131 49.3 106.5 50.5 88.5 55 73.1 61 57.2 67.2 43.7 75.7 30.9 88.5 18 101.3 9.6 114.8 3.4 130.7  -3.6 146.1-8.1 164.1-9.3 188.6-10.4 212.7-10.7 220.6-10.7 282s.2 69.3 1.3 93.4c1.2 24.5 5.7 42.5 11.9 58 6.2 15.9 14.6 29.4 27.4 42.2s26.3 21.2 42.2 27.4c15.5 6.2 33.5 10.7 58 11.9 24.1 1.1 32 1.3 93.4 1.3s69.3-.2 93.4-1.3c24.5-1.2 42.5-5.7 58-11.9 15.9-6.2 29.4-14.6 42.2-27.4s21.2-26.3 27.4-42.2c6.2-15.5 10.7-33.5 11.9-58 1.1-24.1 1.3-32 1.3-93.4s-.2-69.3-1.3-93.4c-1.2-24.5-5.7-42.5-11.9-58-6.2-15.9-14.6-29.4-27.4-42.2S370.2 67.2 354.3 61c-15.5-6.2-33.5-10.7-58-11.9C293.3 48.2 285.4 48 224 48z"
      />
    </svg>
  );
}

// LinkedIn glyph (solid)
function LinkedInLogo() {
  return (
    <svg width="18" height="18" viewBox="0 0 448 512" xmlns="http://www.w3.org/2000/svg" role="img">
      <path
        fill="#FFFFFF"
        d="M100.28 448H7.4V148.9h92.88zM53.79 108.1C24.09 108.1 0 83.5 0 53.8a53.79 53.79 0 1 1 107.58 0c0 29.7-24.1 54.3-53.79 54.3zM447.9 448h-92.68V302.4c0-34.7-.7-79.2-48.29-79.2-48.29 0-55.69 37.7-55.69 76.7V448h-92.78V148.9h89.08v40.8h1.3c12.4-23.5 42.69-48.3 87.88-48.3 94 0 111.28 61.9 111.28 142.3V448z"
      />
    </svg>
  );
}


/* ---------- Styles ---------- */

const styles = {
  container: {
    maxWidth: 440,
    margin: "40px auto",
    padding: 24,
    border: "1px solid #e6e6e6",
    borderRadius: 12,
    boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
    fontFamily: "system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif",
    backgroundColor: "#fff",
  },
  title: { margin: "0 0 8px", fontSize: 24 },
  helper: { margin: "0 0 16px", color: "#555" },
  buttonGroup: {
    display: "grid",
    gridTemplateColumns: "1fr",
    gap: 12,
    marginBottom: 16,
  },
  brandButton: {
    display: "flex",
    alignItems: "center",
    width: "100%",
    minHeight: 44,
    borderRadius: 8,
    borderWidth: 1,
    borderStyle: "solid",
    cursor: "pointer",
    padding: "8px 12px",
    fontWeight: 600,
    fontSize: 14,
    transition: "transform 80ms ease",
  },
  iconWrap: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    width: 20,
    height: 20,
    marginRight: 10,
  },
  btnText: { lineHeight: 1 },
  dividerRow: {
    display: "flex",
    alignItems: "center",
    gap: 8,
    margin: "12px 0 16px",
    color: "#777",
    fontSize: 12,
  },
  dividerLine: {
    flex: 1,
    height: 1,
    backgroundColor: "#e6e6e6",
  },
  infoPanel: {
    background: "#F8FAFD",
    border: "1px solid #E6EDF6",
    borderRadius: 8,
    padding: 12,
    marginBottom: 16,
  },
  infoList: {
    margin: 0,
    paddingLeft: 18,
    color: "#4A5568",
    fontSize: 13,
  },
  toggleRow: { marginTop: 8, color: "#444" },
  toggleBtn: {
    color: "#2563EB",
    background: "transparent",
    border: "none",
    padding: 0,
    cursor: "pointer",
    fontWeight: 600,
  },
  legal: {
    display: "block",
    marginTop: 12,
    color: "#666",
    fontSize: 12,
  },
  link: { color: "#2563EB", textDecoration: "none" },
};

/* ---------- Helper Divider ---------- */
function Divider({ text }) {
  return (
    <div style={styles.dividerRow} role="separator" aria-label={text}>
      <span style={styles.dividerLine} />
      <span>{text}</span>
      <span style={styles.dividerLine} />
    </div>
  );
}
